import getItemRules from '../Rules/getItemRules';
import createBuilding, { ChangeEvent, EventActions } from './buildingFactory';
import { filterObjectsInRange, fixBuildingDataWithRules } from './ruleHelpers';
import { canObjectBePlacedToSegment } from '../Rules/canWallSegmentGetObjectType';

const zWallSegmentsByWidth = {
  4: [4],
  6: [3, 3],
  8: [4, 4],
  10: [5, 5],
  12: [5, 2, 5],
  15: [5, 5, 5],
  16: [5, 6, 5],
  20: [5, 5, 5, 5],
  25: [5, 5, 5, 5, 5],
  30: [5, 5, 5, 5, 5, 5],
  40: [5, 5, 5, 5, 5, 5, 5, 5],
};

const initialState = {
  width: 10,
  length: 10,
  height: 2.3,
  xWallSegmentWidth: 5,
  zWallSegmentsWidth: zWallSegmentsByWidth[10],
  wallType: 'wall_pvc_white',
  roofType: 'roof_type_pvc_white',
  gableType: 'wall_triangle_white',
  rainGutter: false,
  objects: [],
  indexedWallTypes: [],
  highlightColor: 0xeb0045,
};

export function createTent(inputState = {}, store = {}) {
  const building = createBuilding(inputState, {
    calculateDerivedData: (state) => calculateDerivedData(state, store),
    initialState,
  });
  const state = building.getData();

  const { createSetter, dispatch } = building;

  const setWallType = createSetter('wallType', () => {
    state.indexedWallTypes.length = 0;
  });
  const setRoofType = createSetter('roofType');
  const setGableType = createSetter('gableType');
  const setRainGutter = createSetter('rainGutter');

  const setIndexedWallType = (type, side, index, option = null) => {
    const { indexedWallTypes } = state;
    const object = {
      type,
      side,
      index,
      option,
    };

    const existingTypeIndex = indexedWallTypes.findIndex((o) => o.side === side && o.index === index);
    existingTypeIndex !== -1 && indexedWallTypes.splice(existingTypeIndex, 1);
    indexedWallTypes.push(object);

    dispatch(ChangeEvent, {
      action: EventActions.addObject,
      prop: 'indexedWallTypes',
      indexedWallTypes,
      state,
      object,
    });
  };

  return {
    ...building,

    setWallType,
    setRoofType,
    setGableType,
    setRainGutter,

    setIndexedWallType,
  };
}

function setDefaultTypes(state, store) {
  const localOptions = store.getState().Option.localOptions;
  state.wallTypeDefault = localOptions.walls[0];
  state.roofTypeDefault = localOptions.roof[0];
  state.gableTypeDefault = localOptions.wall_triangle[0];
  if (!state.wallType.option) {
    state.wallType = state.wallTypeDefault;
  }
  if (!state.roofType.option) {
    state.roofType = state.roofTypeDefault;
  }
  if (!state.gableType.option) {
    state.gableType = state.gableTypeDefault;
  }
}

function fixWallTypesWithRules(state, rules) {
  if (rules.disabledWallTypes?.length) {
    state.indexedWallTypes = state.indexedWallTypes.filter(
      (wallType) => !rules.disabledWallTypes.includes(wallType.option?.identifier)
    );
    if (rules.disabledWallTypes.includes(state.wallType.option?.identifier)) {
      state.wallType = state.wallTypeDefault;
    }
  }
}

function removeExtraObjects(state) {
  for (let i = 0; i < state.objects.length; i++) {
    const object = state.objects[i];
    const { type, side, index } = object;
    if (!canObjectBePlacedToSegment(state, type, side, index, object)) {
      state.objects.splice(i, 1);
      removeExtraObjects(state);
      break;
    }
  }
}

function getWallSegmentRopeIndex(state) {
  const { width, xWallSegmentCount } = state;
  const indexArr = [0, xWallSegmentCount - 1];
  if (width > 20) {
    indexArr.push(1, xWallSegmentCount - 2);
  }
  if (width > 30) {
    indexArr.push(2, xWallSegmentCount - 3);
  }
  return indexArr;
}

function calculateDerivedData(state, store) {
  setDefaultTypes(state, store);
  const rules = getItemRules(state);
  rules && fixBuildingDataWithRules(state, rules);
  rules && fixWallTypesWithRules(state, rules);

  const xWallSegmentWidth = 5;

  const xWallSegmentCount = state.length / xWallSegmentWidth;
  const xWallSegmentsWidth = Array(xWallSegmentCount).fill(xWallSegmentWidth);

  const zWallSegmentsWidth = zWallSegmentsByWidth[state.width];
  const zWallSegmentCount = zWallSegmentsWidth.length;

  Object.assign(state, {
    xWallSegmentsWidth,
    xWallSegmentCount,
    zWallSegmentsWidth,
    zWallSegmentCount,
  });

  state.ropeIndex = getWallSegmentRopeIndex(state);

  // re-add the objects with validation
  state.objects = filterObjectsInRange(state, state.objects);
  removeExtraObjects(state);
  state.indexedWallTypes = filterObjectsInRange(state, state.indexedWallTypes);

  return state;
}

export default createTent;
